interface LogoProps extends React.ComponentProps<"img"> {
  variant?: "A" | "B" | "C" | "It";
}

export const Logo = ({ variant = "A", ...props }: LogoProps) => {
  return (
    <img
      src={`/logo-variant-${variant.toLowerCase()}.png`}
      alt="Rentinit"
      {...props}
    />
  );
};
